import { InputField } from "@rawa/ui/InputField"
import { fieldInstructions, fieldName } from "../fields"
import type { ControlRenderer } from "./types"

// The value is the date as the input reports it, YYYY-MM-DD, or none once
// it is cleared.
export const datePicker: ControlRenderer<"datePicker"> = {
  Render: ({ field, value, onChange, error }) => (
    <InputField
      id={field.id}
      label={fieldName(field)}
      hint={fieldInstructions(field)}
      type="date"
      value={value ?? ""}
      onChange={(date) => onChange(date === "" ? undefined : date)}
      required={field.required}
      error={error}
    />
  ),
}
